import { render, staticRenderFns } from "./PrkColorPicker.vue?vue&type=template&id=3322c288&scoped=true&"
import script from "./PrkColorPicker.vue?vue&type=script&lang=js&"
export * from "./PrkColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./PrkColorPicker.vue?vue&type=style&index=0&id=3322c288&scoped=true&lang=scss&"
import style1 from "./PrkColorPicker.vue?vue&type=style&index=1&id=3322c288&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322c288",
  null
  
)

export default component.exports